import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {EventosTablaInterface} from '../../interfaces/eventos-tabla.interface';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Constants} from '../../constants/constants';

@Component({
  selector: 'app-modal-visor-documentos',
  templateUrl: './modal-visor-documentos.component.html',
  styleUrls: ['./modal-visor-documentos.component.scss']
})
export class ModalVisorDocumentosComponent {
  @ViewChild('modalVisorDocumento') modal: ElementRef;
  url = '';
  nombreArchivo = '';

  constructor(private modalService: NgbModal, private constants: Constants) {
  }

  showPDF(nombreArchivo: string) {
    if (nombreArchivo.endsWith('pdf')) {
      this.modalService.open(this.modal, {
        backdrop: 'static',
        scrollable: true,
        keyboard: false,
        size: 'xl'
      });
      this.url = this.constants.URL_VER_PDF + nombreArchivo;
    } else {
      window.open(this.constants.URL_DESCARGA_FICHERO + nombreArchivo, '_blank');
    }
    this.nombreArchivo = nombreArchivo;
  }

  showBlob(blob: string) {
    this.modalService.open(this.modal, {
      backdrop: 'static',
      scrollable: true,
      keyboard: false,
      size: 'xl'
    });
    this.url = blob;
  }


}
